"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../shared/controllers/BaseController");
var UITableFilterController = /** @class */ (function (_super) {
    __extends(UITableFilterController, _super);
    function UITableFilterController() {
        return _super.call(this, true) || this;
    }
    UITableFilterController.prototype.ResetData = function () {
        this.DATA = {
            dict: {},
            listKeys: []
        };
    };
    UITableFilterController.prototype.doUIRegisterFilterEmpty = function (key) {
        if (!this.DATA.dict[key]) {
            this.DATA.dict[key] = {
                isFilterActive: false,
                selectedValues: [],
                filterValue: ""
            };
        }
        if (this.DATA.listKeys.indexOf(key) == -1) {
            this.DATA.listKeys.push(key);
        }
    };
    UITableFilterController.prototype.doUIRegisterFilterData = function (key, data) {
        if (!this.DATA.dict[key]) {
            this.DATA.dict[key] = data;
        }
        if (this.DATA.listKeys.indexOf(key) == -1) {
            this.DATA.listKeys.push(key);
        }
    };
    UITableFilterController.prototype.doUIDeleteFilter = function (key) {
        delete this.DATA.dict[key];
        var new_list = this.DATA.listKeys.slice();
        var index = new_list.indexOf(key);
        if (index !== -1) {
            new_list.splice(index, 1);
        }
        this.DATA.listKeys = new_list;
    };
    UITableFilterController.prototype.doUISetFilterActive = function (key, isActive, triggerEvent) {
        this.DATA.dict[key].isFilterActive = isActive;
        if (triggerEvent) {
            this.Update(key);
        }
    };
    UITableFilterController.prototype.doUISetFilterValue = function (key, value, triggerEvent) {
        this.DATA.dict[key].filterValue = value;
        if (triggerEvent) {
            this.Update(key);
        }
    };
    UITableFilterController.prototype.doUISetFilterDataSelectedValues = function (key, data, triggerEvent) {
        this.DATA.dict[key].selectedValues = data;
        if (triggerEvent) {
            this.Update(key);
        }
    };
    UITableFilterController.prototype.getUIFilterItemByKey = function (key) {
        return this.DATA.dict[key];
    };
    UITableFilterController.prototype.isUIFilterItemExists = function (key) {
        if (this.DATA.listKeys.indexOf(key) < 0) {
            return false;
        }
        else {
            return true;
        }
    };
    UITableFilterController.prototype.getUIAllFilterItems = function () {
        var _ret = [];
        for (var i = 0; i < this.DATA.listKeys.length; i++) {
            _ret.push(this.DATA.dict[this.DATA.listKeys[i]]);
        }
        return _ret;
    };
    return UITableFilterController;
}(BaseController_1.BaseController));
exports.UITableFilterController = UITableFilterController;



//////////////////
// WEBPACK FOOTER
// ./src/shared/controllers/UITableFilterController.ts
// module id = 860
// module chunks = 0